class ColumnSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = null;
    this.sliderEl = this.querySelector('.glide');
  }

  connectedCallback() {
    this.slider = new Glide(this.sliderEl, {
      type: 'carousel',
      startAt: 0,
      perView: 5,
      focusAt: 0,
      gap: 24,
      peek: 450,
      breakpoints: {
        3000: {
          perView: 4,
          focusAt: 0,
          gap: 24,
          peek: 450,
        },
        2048: {
          perView: 3,
          focusAt: 0,
          gap: 24,
          peek: 450,
        },
        1673: {
          perView: 3,
          focusAt: 0,
          gap: 24,
          peek: 270,
        },
        1371: {
          perView: 2,
          peek: 400,
          gap: 34,
          focusAt: 0,
        },
        1157: {
          perView: 2,
          peek: 300,
          gap: 34,
          focusAt: 0,
        },
        930: {
          perView: 2,
          peek: 200,
          gap: 18,
          focusAt: 0,
        },
        655: {
          perView: 2,
          peek: 100,
          gap: 10,
          focusAt: 0,
        },
        450: {
          perView: 1,
          peek: 100,
          gap: 10,
          focusAt: 0,
        }
      }
    });

    this.slider.on('mount.after', this.updateBullets.bind(this));
    this.slider.on('run.after', this.updateBullets.bind(this));

    this.slider = this.slider.mount();
  }

  updateBullets () {
    this.querySelectorAll('.glide__bullet')
      .forEach(el => el.classList.remove('glide__bullet--active'));

    this.querySelector(`.glide__bullet[data-glide-dir="=${this.slider.index}"]`).classList.add('glide__bullet--active')
  }
}

customElements.define('column-slider', ColumnSlider);